import { Box, Button, Card, Typography } from '@mui/material'
import MDBox from 'components/MDBox'
import RTLDataGrid from 'components/styled-component/RTLDataGrid'
import React from 'react'
import groupsApi, { useGetGroupsQuery } from '../../redux/Slices/groupsApi'
import { columns } from './columns'
import AddTeamModal from 'components/AddTeamModal'

const Groups = () => {

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [totalCount, setTotalCount] = React.useState(0);
    const [modalOpen, setModalOpen] = React.useState(false);
    const query = new URLSearchParams({
        page: page + 1,
        per_page: rowsPerPage,
        status:"active",
        subscription_plan:"pro"
    }).toString()
    const {data:teams, isLoading} = useGetGroupsQuery(query)
    
    

  return (
    <>
    <AddTeamModal
            open={modalOpen}
            onClose={() => {
              setModalOpen(false);
              
            }}
           
          />
    <MDBox dir={"rtl"} sx={{ p: 3, minHeight: "100vh" }}>
        <Card sx={{ mb: 3 }}>
        {/* Header */}
        <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    borderRadius="lg"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                      background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                      boxShadow: 3,
                    }}
                  > 
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            إدارة المجموعات
          </Typography>
          <Button
          variant="contained"
          color="text"
          sx={{
            color:"#111"
          }}
          onClick={() =>setModalOpen(true) }
          >
            إضافة مجموعة
          </Button>
        </MDBox>

            <Box my={4}>

            
                <RTLDataGrid
                rows={teams?.data}
                columns={columns}
                 rowCount={teams?.meta?.total}
                    paginationMode="server"
                    paginationModel={{ page, pageSize: rowsPerPage }}
                    onPaginationModelChange={(model) => {
                      setPage(model.page);
                      setRowsPerPage(model.pageSize);
                    }}
                loading={isLoading}
                />
            </Box>
        </Card>
    </MDBox>
    </>
  )
}

export default Groups